import {
    AllCommunityModule,
    CellDoubleClickedEvent,
    CellValueChangedEvent,
    ColDef,
    DetailGridInfo,
    FirstDataRenderedEvent,
    GetRowIdParams,
    GridReadyEvent,
    ICellRendererParams,
    INumberCellEditorParams,
    IRichCellEditorParams,
    KeyCreatorParams,
    ValueFormatterParams,
    ValueParserParams,
  } from "ag-grid-community";
  import React, {
    memo,
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
  } from "react";
  import {
    AccountantAccount,
    DebtData,
    Permission,
    Program,
  } from "../PaymentReceipt/InternalReceipt/InternalReceiptModel";
  import {
    AgGridReact,
    CustomCellEditorProps,
    CustomCellRendererProps,
  } from "ag-grid-react";
  import { MessageResponse } from "../../../model/MessageResponse";
  import {
    baseTheme,
    paginationPageSize,
    paginationPageSizeSelector,
    repositoryDelivery,
    repositoryMdm,
    repositoryPos,
  } from "../../../_base/_const/_constVar";
  import { MRT_PaginationState } from "mantine-react-table";
  import {
    ActionIcon,
    Badge,
    Box,
    Button,
    Flex,
    Grid,
    Group,
    Input,
    Select,
    SelectProps,
    Text,
    Title,
    Tooltip,
  } from "@mantine/core";
  import { useDebouncedCallback } from "@mantine/hooks";
  import {
    IconBrandBootstrap,
    IconBuildingSkyscraper,
    IconCheck,
    IconCoinPound,
    IconDeviceFloppy,
    IconSearch,
    IconTicket,
    IconTimeDuration15,
    IconUser,
    IconWriting,
    IconX,
  } from "@tabler/icons-react";
  import { DateInput, DatePickerInput } from "@mantine/dates";
  import { SelectListItem } from "../../../model/SelectListItem";
  import { SelectListItemBase } from "../../../_base/model/_base/SelectListItemBase";
  import { orange } from "../../../const/variables";
  import { AG_GRID_LOCALE_VN } from "@ag-grid-community/locale";
  import { TblDMPaymentMethod } from "../../../model/TblDMPaymentMethod";
  import { modals } from "@mantine/modals";
  import DebtObjectCodeFund from "../Bill/DebtObject/DebtObject";
  import { useNavigate } from "react-router-dom";
  import FormAccount from "../Bill/FormAccount/FormAccount";
  import {
    ClientSideRowModelModule,
    ModuleRegistry,
    DateEditorModule,
    MasterDetailModule,
  } from "ag-grid-enterprise";
  // import creatorbranchEditor from "./creatorbranchEdit";
  import { EmployeeModel } from "../../../model/Employee";
  import {
    CreateReceiptParentRequest,
    DepartmentUser,
  } from "../PaymentReceipt/model/modelPaymentReceipt";
  import { notifications } from "@mantine/notifications";
  import ListCustomer from "../Bill/ListCustomer/ListCustomer";
  import ListSupplier from "../Bill/ListSupplier/ListSupplier";
  import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
  import CustomerByBranch from "../Bill/CustomerByBranch/CustomerByBranch";
  import ListEmployeebyBranch from "../Bill/ListEmployeebyBranch/ListEmployeebyBranch";
  import ListEmployeebyBranch2 from "../Bill/ListEmployeebyBranch2/ListEmployeebyBranch2";
  import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
  import { useForm } from "@mantine/form";
  import { addHours, set } from "date-fns";
  
  ModuleRegistry.registerModules([
    ClientSideRowModelModule,
    AllCommunityModule,
    DateEditorModule,
    MasterDetailModule,
  ]);
  
  interface DataList {
    lists: any[];
    count: number;
  }
  
  interface AccountantAccounts {
    id: number;
    accountantAccount: string;
    accountantAccountName: string;
    accountLevel: number;
    createBy?: string | null;
    createDate?: Date | null;
    lastUpdateDate?: Date | null;
    lastUpdateBy?: string | null;
  }
  interface DepartmentInfo {
    active: boolean;
    address: string | null;
    attribute1: string | null;
    attribute2: string | null;
    attribute3: string | null;
    branchId: number;
    createdBy: string | null;
    creationDate: string | null;
    deparmentCode: string;
    departmentId: number;
    description: string | null;
    lastUpdateDate: string | null;
    lastUpdatedBy: string | null;
    name: string;
  }
  interface ItemTransactionEditMode {
    transactionId: number;
    transactionCode: string;
    createDate?: Date;
    description: string;
    branchId?: number;
    branchName: string;
    saleId?: number;
    saleName: string;
    saleCode: string;
    finishDate?: Date;
    sourceType: string;
  }
  
  interface OrderModelSearch {
    invId?: number;
    invOutwardId?: number;
    customerId?: number;
    startDate?: Date | string; // ISO date string
    endDate?: Date | string; // ISO date string
    orderStatus?: string;
    orderCode?: string;
    orderNumber?: string;
    paymentStatus?: string;
    industry?: string;
    orderType?: number;
    outWardStatus?: string;
    technicalStatus?: string;
    shippingStatus?: string;
    createBy?: number;
    phone?: string;
    codeCustomer?: string;
    keySearch?: string;
  }
  export const AdjustmentSlipTransaction = () => {
    const [height, setHeight] = useState(0);
    const sizeGrid = { base: 6, sm: 2, md: 2, lg: 2, xl: 2 };
    const [data, setData] = useState<ItemTransactionEditMode[]>([]);
    const gridRef = useRef<AgGridReact<ItemTransactionEditMode>>(null);
    const editListRef = useRef(new Set<number>());
  
    const form = useForm<OrderModelSearch>({
      initialValues: {},
    });
  
    const headerRef = React.useRef<HTMLDivElement>(null);
  
    const containerStyle = useMemo(
      () => ({ width: "100%", height: height - 20, marginTop: "15px" }),
      [height]
    );
    const defaultColDef = useMemo<ColDef<ItemTransactionEditMode>>(() => {
      return {
        //  flex: 1,
        editable: true,
      };
    }, []);
  
    const onCellValueChanged = useCallback(
      (params: CellValueChangedEvent<ItemTransactionEditMode>) => {
        const colId = params.data.transactionId;
        editListRef.current.add(colId);
      },
      []
    );
  
    const fetchData = async () => {
      try {
        // Tạo queryParams, chỉ thêm các giá trị hợp lệ
        let _da = {
          ...form.getValues(),
        };
        if (_da.startDate && _da.startDate != null)
          _da.startDate = addHours(_da.startDate, 7).toISOString();
        else _da.startDate = "";
        if (_da.endDate) _da.endDate = addHours(_da.endDate, 7).toISOString();
        else _da.endDate = "";
        if (_da.createBy) _da.createBy = Number(_da.createBy);
        else _da.createBy = 0;
        // Chuyển queryParams thành chuỗi URL
        const url =
          "/api/v1/CreateSellItem/get-list-inventory-edit?" +
          new URLSearchParams(_da as Record<string, string>).toString();
  
        // Gọi API
        const response = await repositoryPos.get<
          MessageResponse<ItemTransactionEditMode[]>
        >(url);
  
        if (response && response.success) {
          setData(response.data);
          //  setRowCount(response.totalCount);
        }
      } catch (error) {
        console.error(error);
      }
    };
  
    //danh sách theo từng hàng
    const columnDefs = useMemo<ColDef<ItemTransactionEditMode>[]>(
      () => [
        {
          field: "transactionCode",
          headerName: "Mã phiếu",
          filter: "agTextColumnFilter",
          pinned: "left",
          maxWidth: 200,
          editable: false,
        },
        {
          field: "createDate",
          headerName: "Thời gian tạo",
          editable: false,
          valueFormatter: (
            params: ValueFormatterParams<ItemTransactionEditMode, Date>
          ) => {
            if (!params.value) {
              return "";
            }
  
            const date = new Date(params.value);
            if (isNaN(date.getTime())) {
              return "Sai định dạng ngày !";
            }
  
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const day = date.getDate();
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const seconds = date.getSeconds();
  
            return `${year}-${month < 10 ? "0" + month : month}-${
              day < 10 ? "0" + day : day
            } ${hours < 10 ? "0" + hours : hours}:${
              minutes < 10 ? "0" + minutes : minutes
            }:${seconds < 10 ? "0" + seconds : seconds}`;
          },
          cellEditor: "agTextCellEditor",
          minWidth: 200,
        },
        {
          field: "finishDate",
          headerName: "Thời gian hoàn thành",
          valueFormatter: (
            params: ValueFormatterParams<ItemTransactionEditMode, Date>
          ) => {
            if (!params.value) {
              return "";
            }
  
            const date = new Date(params.value);
            if (isNaN(date.getTime())) {
              return "Sai định dạng ngày !";
            }
  
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const day = date.getDate();
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const seconds = date.getSeconds();
  
            return `${year}-${month < 10 ? "0" + month : month}-${
              day < 10 ? "0" + day : day
            } ${hours < 10 ? "0" + hours : hours}:${
              minutes < 10 ? "0" + minutes : minutes
            }:${seconds < 10 ? "0" + seconds : seconds}`;
          },
          cellEditor: "agTextCellEditor",
          minWidth: 200,
        },
        {
          field: "branchName",
          headerName: "Bộ phận người lập phiếu",
          filter: "agNumberColumnFilter",
          minWidth: 300,
          editable: false,
        },
        {
          field: "saleName",
          headerName: "Nhân viên bán hàng",
          filter: "agTextColumnFilter",
          minWidth: 230,
        },
        {
          field: "description",
          headerName: "Ghi chú",
          filter: "agTextColumnFilter",
          minWidth: 350,
          editable: false,
          cellEditorPopup: true,
        },
      ],
      [data]
    );
  
    const handleComplete = async () => {
      try {
        const response = await repositoryPos.post<
          MessageResponse<CreateReceiptParentRequest>
        >("api/v1/CreateSellItem/update-inventory-list", {
          orderHeaders: data.filter((item) =>
            editListRef.current.has(item.transactionId)
          ),
        });
  
        if (response && response.httpStatusCode === 200 && response?.success) {
          if (response.success) {
            await fetchData();
            editListRef.current.clear();
            NotificationExtension.Success("Điều chỉnh phiếu thành công !");
          } else {
            NotificationExtension.Fails("Điều chỉnh phiếu thất !");
          }
        }
      } catch (error) {
        console.error(error);
        NotificationExtension.Fails("Có lỗi xảy ra khi điều chỉnh phiếu thất !");
      }
    };
  
    useEffect(() => {
      const headerHeight = headerRef.current?.offsetHeight || 0;
      const handleResize = () => {
        setHeight(window.innerHeight - (200 + headerHeight));
      };
  
      handleResize();
      window.addEventListener("resize", handleResize);
  
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, [height]);
  
    return (
      <div style={containerStyle}>
        <Group justify="space-between">
          <_breadcrumb></_breadcrumb>
          <Flex gap={10}>
            <Button
              leftSection={<IconDeviceFloppy size={14} />}
              color="blue"
              bd="1px solid blue"
              variant="light"
              onClick={() => handleComplete()}
            >
              Lưu thay đổi
            </Button>
          </Flex>
        </Group>
        <Grid mt={5} mb={5}>
          <Grid.Col span={{ base: 6, sm: 6, md: 6, lg: 4 }}>
            <Input
              key={form.key("keySearch")}
              placeholder="Từ khóa (tìm nhiều đơn VD: DH1,DH2,DH3)"
              type="text"
              leftSection={<IconSearch color="#15aabf" />}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchData();
                }
              }}
              {...form.getInputProps("keySearch")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              key={form.key("startDate")}
              type="default"
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Từ ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              {...form.getInputProps("startDate")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              key={form.key("endDate")}
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Đến ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              {...form.getInputProps("endDate")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Button
              leftSection={<IconSearch size={14} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
  
        <div
          style={{ height: "100%", boxSizing: "border-box", paddingTop: "10px" }}
        >
          <AgGridReact<ItemTransactionEditMode>
            ref={gridRef}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            onCellValueChanged={onCellValueChanged}
            rowData={data}
            theme={baseTheme}
            suppressColumnVirtualisation={true}
            suppressRowVirtualisation={true}
            pagination={true}
            localeText={AG_GRID_LOCALE_VN}
            autoSizeStrategy={{
              type: "fitCellContents",
            }}
            paginationPageSize={paginationPageSize}
            paginationPageSizeSelector={paginationPageSizeSelector}
          />
        </div>
      </div>
    );
  };
  